import ContentLoader from "react-content-loader";

const ContactListLoader = (props: any) => {
  const { loading } = props;
  return (
    <>
      {loading ? (
        <>
          <ContentLoader
            style={{ backgroundColor: "#FFFFFF", marginBottom: "10px", borderRadius: "10px" }}
            // viewBox="0 0 0 0"
            height={100}
            width={props.width ? props.width : "100%"}
            {...props}
            loading={props?.loading?.toString()}
          >
            <rect x="160" y="68" rx="8" ry="8" width="80%" height="18" />
            <circle y="8" cx="100" cy="50" r="45" />
            <rect x="160" y="37" rx="8" ry="8" width="80%" height="18" />
            <rect x="160" y="10" rx="8" ry="8" width="80%" height="18" />
          </ContentLoader>
          <ContentLoader
            style={{ backgroundColor: "#FFFFFF", marginBottom: "10px", borderRadius: "10px" }}
            // viewBox="0 0 0 0"
            height={100}
            width={props.width ? props.width : "100%"}
            {...props}
            loading={props?.loading?.toString()}
          >
            <rect x="160" y="68" rx="8" ry="8" width="80%" height="18" />
            <circle y="8" cx="100" cy="50" r="45" />
            <rect x="160" y="37" rx="8" ry="8" width="80%" height="18" />
            <rect x="160" y="10" rx="8" ry="8" width="80%" height="18" />
          </ContentLoader>
          <ContentLoader
            style={{ backgroundColor: "#FFFFFF", marginBottom: "10px", borderRadius: "10px" }}
            // viewBox="0 0 0 0"
            height={100}
            width={props.width ? props.width : "100%"}
            {...props}
            loading={props?.loading?.toString()}
          >
            <rect x="160" y="68" rx="8" ry="8" width="80%" height="18" />
            <circle y="8" cx="100" cy="50" r="45" />
            <rect x="160" y="37" rx="8" ry="8" width="80%" height="18" />
            <rect x="160" y="10" rx="8" ry="8" width="80%" height="18" />
          </ContentLoader>
          <ContentLoader
            style={{ backgroundColor: "#FFFFFF", marginBottom: "10px", borderRadius: "10px" }}
            // viewBox="0 0 0 0"
            height={100}
            width={props.width ? props.width : "100%"}
            {...props}
            loading={props?.loading?.toString()}
          >
            <rect x="160" y="68" rx="8" ry="8" width="80%" height="18" />
            <circle y="8" cx="100" cy="50" r="45" />
            <rect x="160" y="37" rx="8" ry="8" width="80%" height="18" />
            <rect x="160" y="10" rx="8" ry="8" width="80%" height="18" />
          </ContentLoader>
        </>
      ) : null}
    </>
  );
};
export default ContactListLoader;
